import { render, staticRenderFns } from "./ScoreCard.vue?vue&type=template&id=09935b7a&scoped=true&"
import script from "./ScoreCard.vue?vue&type=script&lang=js&"
export * from "./ScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCard.vue?vue&type=style&index=0&id=09935b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09935b7a",
  null
  
)

export default component.exports